export enum TAG_TYPE {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
}

export enum COMMUNICATION_TAG_TYPE {
  USER_TAG = 'user_tag',
  AUDIENCE_TAG = 'audience_tag',
}
